import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DSDateInput from '@elliemae/ds-basic/form/DateInputV2';
import DSInputGroup from '@elliemae/ds-basic/form/InputGroup';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var blockname = 'date-range-picker';
var DATE_FORMAT = 'MMDDYYYY'; // When year is greater than 999 it means the user finished writing
// the year for the range, because they must type 4 numbers for the year
// to be higher than 999

var MAGIC_NUMBER = 999;
var Header = aggregatedClasses('div')(blockname, 'header', function (_ref) {
  var invalidDate = _ref.invalidDate;
  return {
    invalidDate: invalidDate
  };
});

var DatePickerRangeHeader = function DatePickerRangeHeader(_ref2) {
  var _ref2$onStartInputCha = _ref2.onStartInputChange,
      onStartInputChange = _ref2$onStartInputCha === void 0 ? function () {
    return null;
  } : _ref2$onStartInputCha,
      _ref2$onEndInputChang = _ref2.onEndInputChange,
      onEndInputChange = _ref2$onEndInputChang === void 0 ? function () {
    return null;
  } : _ref2$onEndInputChang,
      _ref2$onFocusChange = _ref2.onFocusChange,
      onFocusChange = _ref2$onFocusChange === void 0 ? function () {
    return null;
  } : _ref2$onFocusChange,
      selectedStartDate = _ref2.selectedStartDate,
      selectedEndDate = _ref2.selectedEndDate,
      handleDatesChange = _ref2.handleDatesChange,
      _ref2$autoJumpOnEdit = _ref2.autoJumpOnEdit,
      autoJumpOnEdit = _ref2$autoJumpOnEdit === void 0 ? true : _ref2$autoJumpOnEdit;

  var _useState = useState(selectedStartDate),
      _useState2 = _slicedToArray(_useState, 2),
      startValue = _useState2[0],
      setStartValue = _useState2[1];

  var _useState3 = useState(selectedEndDate),
      _useState4 = _slicedToArray(_useState3, 2),
      endValue = _useState4[0],
      setEndValue = _useState4[1];

  var startInputRef = useRef();
  var endInputRef = useRef();
  useEffect(function () {
    if (selectedStartDate) {
      setStartValue(selectedStartDate.format(DATE_FORMAT));
    }

    if (selectedEndDate) {
      setEndValue(selectedEndDate.format(DATE_FORMAT));
    }
  }, [selectedStartDate, selectedEndDate]);

  var isValidRangeDate = function isValidRangeDate(start, end) {
    var isValidRange = false;

    if (start && end) {
      var momentStart = moment(start, DATE_FORMAT);
      var momentEnd = moment(end, DATE_FORMAT);
      isValidRange = momentStart.isBefore(momentEnd);
    }

    return isValidRange;
  };

  var handleOnFocus = function handleOnFocus(inputType) {
    return onFocusChange(inputType);
  };

  var handleOnChangeStart = function handleOnChangeStart(newStartValue) {
    var _endInputRef$current, _endInputRef$current$;

    var y = newStartValue.substring(4);
    var momentValue = moment(newStartValue, DATE_FORMAT);

    if (newStartValue && newStartValue.length === DATE_FORMAT.length) {
      onStartInputChange(momentValue);
    }

    setStartValue(newStartValue);

    if (autoJumpOnEdit && parseInt(y, 10) > MAGIC_NUMBER && endInputRef !== null && endInputRef !== void 0 && (_endInputRef$current = endInputRef.current) !== null && _endInputRef$current !== void 0 && (_endInputRef$current$ = _endInputRef$current.firstChild) !== null && _endInputRef$current$ !== void 0 && _endInputRef$current$.focus) {
      endInputRef.current.firstChild.focus();
    }
  };

  var handleOnChangeEnd = function handleOnChangeEnd(newEndValue) {
    var momentValue = moment(newEndValue, DATE_FORMAT);

    if (isValidRangeDate(startValue, newEndValue) && newEndValue && newEndValue.length === DATE_FORMAT.length) {
      onEndInputChange(momentValue);
    }

    setEndValue(newEndValue);
  };

  var handleOnKeyDownStart = function handleOnKeyDownStart(e) {
    var isValid = isValidRangeDate(startValue, endValue);
    var momentStart = moment(startValue, DATE_FORMAT);
    var momentEnd = moment(endValue, DATE_FORMAT);

    if (e.key === 'Enter' && startValue) {
      onStartInputChange(momentStart);
      if (isValid) handleDatesChange({
        startDate: momentStart,
        endDate: momentEnd
      });
    }
  };

  var handleOnKeyDownEnd = function handleOnKeyDownEnd(e) {
    var isValid = isValidRangeDate(startValue, endValue);
    var momentStart = moment(startValue, DATE_FORMAT);
    var momentEnd = moment(endValue, DATE_FORMAT);

    if (e.key === 'Enter' && isValid) {
      handleDatesChange({
        startDate: momentStart,
        endDate: momentEnd
      });
      onEndInputChange(momentEnd);
    }
  };

  return /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(DSInputGroup, null, /*#__PURE__*/React.createElement(DSDateInput, {
    containerProps: {
      'data-testid': 'start-date'
    },
    innerRef: startInputRef,
    onChange: handleOnChangeStart,
    onFocus: function onFocus() {
      return handleOnFocus('startDate');
    },
    onKeyDown: handleOnKeyDownStart,
    value: startValue
  }), /*#__PURE__*/React.createElement(DSDateInput, {
    containerProps: {
      'data-testid': 'end-date'
    },
    innerRef: endInputRef,
    onChange: handleOnChangeEnd,
    onFocus: function onFocus() {
      return handleOnFocus('endDate');
    },
    onKeyDown: handleOnKeyDownEnd,
    value: endValue
  })));
};

DatePickerRangeHeader.propTypes = {
  onStartInputChange: PropTypes.func,
  onEndInputChange: PropTypes.func,
  onFocusChange: PropTypes.func,
  selectedStartDate: PropTypes.any,
  selectedEndDate: PropTypes.any,
  handleDatesChange: PropTypes.func,
  autoJumpOnEdit: PropTypes.bool
};

export default DatePickerRangeHeader;
//# sourceMappingURL=DatePickerRangeHeader.js.map
